export default __webpack_public_path__ + "static/media/PipePole_Stackable.256.8fae6c3c.png";